import React from "react";
import PropTypes from "prop-types";

export function Error({ message }) {
  return (
    <div className="alert alert-danger">
      <strong>Error!</strong> {message}
    </div>
  );
}

Error.propTypes = {
  message: PropTypes.string.isRequired,
};
